import * as React from "react";
import classnames from "classnames";
import { Button } from "@grandvisionhq/common";
import Form from "../../Form/Form/Form.js";
import Input from "../../Input/Input/Input.js";
/* empty css                      */
import { VoucherScannerAndTriggerContainer } from "../../VoucherScannerAndTrigger/VoucherScannerAndTrigger/VoucherScannerAndTriggerContainer.js";
const DiscountCodeForm = ({
  onSubmit,
  content,
  showVoucherScanner,
  buttonCaptionLabel,
  placeholderLabel,
  className,
  "data-t": dataT,
  shouldClearDiscountCode = false
}) => {
  const [inputValue, setInputValue] = React.useState("");
  const [hasError, setHasError] = React.useState(false);
  React.useEffect(() => {
    if (shouldClearDiscountCode) {
      setInputValue("");
    }
  }, [shouldClearDiscountCode]);
  const handleVoucherCode = React.useCallback((decodedText) => {
    setInputValue(decodedText);
  }, []);
  if (!content) {
    return null;
  }
  const { type, inputId } = content.inputField;
  const formClass = classnames("discount-code-form", {
    "discount-code-form--error": hasError
  });
  return /* @__PURE__ */ React.createElement("div", { className: formClass, onAnimationEnd: formAnimationEnd }, /* @__PURE__ */ React.createElement(
    Form,
    {
      name: "discount-code",
      className: classnames("discount-code-form__form", className),
      "data-t": dataT,
      onSubmit: handleOnSubmit,
      showErrorsOnInvalidSubmit: false
    },
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: inputId,
        className: "form-control__input discount-code-form__input",
        "data-t": dataT,
        type,
        initialValue: inputValue,
        placeholder: placeholderLabel,
        onChange: handleOnChange
      }
    ),
    /* @__PURE__ */ React.createElement(
      Button,
      {
        size: "custom",
        className: "discount-code-form__button",
        caption: buttonCaptionLabel,
        onClick: handleOnSubmit,
        variant: "outline"
      }
    )
  ), showVoucherScanner && /* @__PURE__ */ React.createElement(VoucherScannerAndTriggerContainer, { onCodeDetected: handleVoucherCode }));
  function handleOnChange({ value }) {
    setInputValue(value);
  }
  function handleOnSubmit() {
    if (!inputValue) {
      setHasError(true);
      return;
    }
    onSubmit(inputValue);
  }
  function formAnimationEnd() {
    setHasError(false);
  }
};
export {
  DiscountCodeForm,
  DiscountCodeForm as default
};
//# sourceMappingURL=DiscountCodeForm.js.map
